import React from 'react';
import styled from 'styled-components';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import PopupResult from '@ertelecom/ui-react/components/popups/popupResult';

const Button = styled(StyledButton)`
    margin-top: 40px;
    @media (min-width: 400px) {
        max-width: 220px;
    }
    
`;

export default class PopupResponse extends React.Component {
    close = () => {
        const { onClose, onButtonClick } = this.props;
        onButtonClick();
        onClose();
    }

    render() {
        const { onClose, isOpen, title, text, buttonText } = this.props;
        return (
            <PopupResult
                isOpen={isOpen}
                onClose={onClose}
                title={title}
                text={text}>
                {
                    buttonText ? <Button type='primary' text={buttonText} onClick={this.close} /> : null
                }
            </PopupResult>
        );
    }
}
